var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18next from "i18next";
import L from "leaflet";
import { autorun, computed, observable, makeObservable } from "mobx";
import Cartesian2 from "terriajs-cesium/Source/Core/Cartesian2";
import Cartographic from "terriajs-cesium/Source/Core/Cartographic";
import CesiumCredit from "terriajs-cesium/Source/Core/Credit";
import defined from "terriajs-cesium/Source/Core/defined";
import CesiumEvent from "terriajs-cesium/Source/Core/Event";
import CesiumMath from "terriajs-cesium/Source/Core/Math";
import TileProviderError from "terriajs-cesium/Source/Core/TileProviderError";
import WebMercatorTilingScheme from "terriajs-cesium/Source/Core/WebMercatorTilingScheme";
import SplitDirection from "terriajs-cesium/Source/Scene/SplitDirection";
import isDefined from "../../Core/isDefined";
import TerriaError from "../../Core/TerriaError";
import getUrlForImageryTile from "../ImageryProvider/getUrlForImageryTile";
const swScratch = new Cartographic();
const neScratch = new Cartographic();
const swTileCoordinatesScratch = new Cartesian2();
const neTileCoordinatesScratch = new Cartesian2();
class Credit extends CesiumCredit {
  constructor() {
    super(...arguments);
    _defineProperty(this, "_shownInLeaflet", void 0);
    _defineProperty(this, "_shownInLeafletLastUpdate", void 0);
  }
}
let ImageryProviderLeafletTileLayer = (_class = class ImageryProviderLeafletTileLayer extends L.TileLayer {
  constructor(leaflet, imageryProvider) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    super(undefined, _objectSpread(_objectSpread({}, options), {}, {
      updateInterval: defined(imageryProvider._leafletUpdateInterval) ? imageryProvider._leafletUpdateInterval : 100
    }));
    this.leaflet = leaflet;
    this.imageryProvider = imageryProvider;
    _defineProperty(this, "tileSize", 256);
    _defineProperty(this, "errorEvent", new CesiumEvent());
    _defineProperty(this, "initialized", false);
    _defineProperty(this, "_usable", false);
    _defineProperty(this, "_delayedUpdate", void 0);
    _defineProperty(this, "_zSubtract", 0);
    _defineProperty(this, "_requestImageError", void 0);
    _defineProperty(this, "_previousCredits", []);
    _defineProperty(this, "_leafletUpdateInterval", void 0);
    _initializerDefineProperty(this, "splitDirection", _descriptor, this);
    _initializerDefineProperty(this, "splitPosition", _descriptor2, this);
    makeObservable(this);
    this.imageryProvider = imageryProvider;

    // Handle splitter rection (and disposing reaction)
    let disposeSplitterReaction;
    this.on("add", () => {
      if (!disposeSplitterReaction) {
        disposeSplitterReaction = this._reactToSplitterChange();
      }
    });
    this.on("remove", () => {
      if (disposeSplitterReaction) {
        disposeSplitterReaction();
        disposeSplitterReaction = undefined;
      }
    });
    this._leafletUpdateInterval = defined(imageryProvider._leafletUpdateInterval) ? imageryProvider._leafletUpdateInterval : 100;

    // Hack to fix "Space between tiles on fractional zoom levels in Webkit browsers" (https://github.com/Leaflet/Leaflet/issues/3575#issuecomment-688644225)
    this.on("tileloadstart", event => {
      event.tile.style.width = this.getTileSize().x + 0.5 + "px";
      event.tile.style.height = this.getTileSize().y + 0.5 + "px";
    });
  }
  _reactToSplitterChange() {
    return autorun(() => {
      const container = this.getContainer();
      if (container === null) {
        return;
      }
      if (this.splitDirection === SplitDirection.LEFT) {
        const {
          left: clipLeft
        } = this._clipsForSplitter;
        container.style.clip = clipLeft;
      } else if (this.splitDirection === SplitDirection.RIGHT) {
        const {
          right: clipRight
        } = this._clipsForSplitter;
        container.style.clip = clipRight;
      } else {
        container.style.clip = "auto";
      }
    });
  }
  get _clipsForSplitter() {
    let clipLeft = "";
    let clipRight = "";
    let clipPositionWithinMap;
    let clipX;
    if (this.leaflet.size && this.leaflet.nw && this.leaflet.se) {
      clipPositionWithinMap = this.leaflet.size.x * this.splitPosition;
      clipX = Math.round(this.leaflet.nw.x + clipPositionWithinMap);
      clipLeft = "rect(" + [this.leaflet.nw.y, clipX, this.leaflet.se.y, this.leaflet.nw.x].join("px,") + "px)";
      clipRight = "rect(" + [this.leaflet.nw.y, this.leaflet.se.x, this.leaflet.se.y, clipX].join("px,") + "px)";
    }
    return {
      left: clipLeft,
      right: clipRight,
      clipPositionWithinMap: clipPositionWithinMap,
      clipX: clipX
    };
  }
  _tileOnError(_done, _tile, _e) {
    // Do nothing, we'll handle tile errors separately.
  }
  createTile(coords, done) {
    // Create a tile (Image) as normal.
    const tile = super.createTile(coords, done);

    // By default, Leaflet handles tile load errors by setting the Image to the error URL and raising
    // an error event.  We want to first raise an error event that optionally returns a promise and
    // retries after the promise resolves.

    const _doRequest = waitPromise => {
      if (waitPromise) {
        waitPromise.then(function () {
          _doRequest();
        }).catch(e => {
          // The tile has failed irrecoverably, so invoke Leaflet's standard
          // tile error handler.
          L.TileLayer.prototype._tileOnError.call(this, done, tile, e);
        });
        return;
      }

      // Setting src will trigger a new load or error event, even if the
      // new src is the same as the old one.
      const tileUrl = this.getTileUrl(coords);
      if (isDefined(tileUrl)) {
        tile.src = tileUrl;
      }
    };
    L.DomEvent.on(tile, "error", e => {
      const level = this._getLevelFromZ(coords);
      const message = i18next.t("map.cesium.failedToObtain", {
        x: coords.x,
        y: coords.y,
        level: level
      });
      this._requestImageError = TileProviderError.reportError(this._requestImageError,
      // TODO: Cesium type definitions incorrectly forbid undefined
      this.imageryProvider, this.imageryProvider.errorEvent, message, coords.x, coords.y, level, e
      // TODO: bring terriajs-cesium retry logic to cesium
      //doRequest
      );
    });
    return tile;
  }
  getTileUrl(tilePoint) {
    const level = this._getLevelFromZ(tilePoint);
    const errorTileUrl = this.options.errorTileUrl || "";
    if (level < 0) {
      return errorTileUrl;
    }
    return getUrlForImageryTile(this.imageryProvider, tilePoint.x, tilePoint.y, level) || errorTileUrl;
  }
  _getLevelFromZ(tilePoint) {
    return tilePoint.z - this._zSubtract;
  }
  _update() {
    if (!this.initialized) {
      this.initialized = true;

      // Cancel the existing delayed update, if any.
      if (this._delayedUpdate) {
        clearTimeout(this._delayedUpdate);
        this._delayedUpdate = undefined;
      }
      this._delayedUpdate = setTimeout(() => {
        this._delayedUpdate = undefined;

        // If we're no longer attached to a map, do nothing.
        if (!this._map) {
          return;
        }
        const tilingScheme = this.imageryProvider.tilingScheme;
        if (!(tilingScheme instanceof WebMercatorTilingScheme)) {
          this.errorEvent.raiseEvent(this, i18next.t("map.cesium.notWebMercatorTilingScheme"));
          return;
        }
        if (tilingScheme.getNumberOfXTilesAtLevel(0) === 2 && tilingScheme.getNumberOfYTilesAtLevel(0) === 2) {
          this._zSubtract = 1;
        } else if (tilingScheme.getNumberOfXTilesAtLevel(0) !== 1 || tilingScheme.getNumberOfYTilesAtLevel(0) !== 1) {
          this.errorEvent.raiseEvent(this, i18next.t("map.cesium.unusalTilingScheme"));
          return;
        }
        if (isDefined(this.imageryProvider.maximumLevel)) {
          this.options.maxNativeZoom = this.imageryProvider.maximumLevel;
        }
        if (defined(this.imageryProvider.minimumLevel)) {
          this.options.minNativeZoom = this.imageryProvider.minimumLevel;
        }
        if (isDefined(this.imageryProvider.credit)) {
          this._map.attributionControl.addAttribution(getCreditHtml(this.imageryProvider.credit));
        }
        this._usable = true;
        this._update();
      }, this._leafletUpdateInterval);
    }
    if (this._usable) {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      L.TileLayer.prototype._update.apply(this, args);
      this._updateAttribution();
    }
  }
  _updateAttribution() {
    if (!this._usable || !isDefined(this.imageryProvider.getTileCredits)) {
      return;
    }
    for (let i = 0; i < this._previousCredits.length; ++i) {
      this._previousCredits[i]._shownInLeafletLastUpdate = this._previousCredits[i]._shownInLeaflet;
      this._previousCredits[i]._shownInLeaflet = false;
    }
    const bounds = this._map.getBounds();
    const zoom = this._map.getZoom() - this._zSubtract;
    const tilingScheme = this.imageryProvider.tilingScheme;
    swScratch.longitude = Math.max(CesiumMath.negativePiToPi(CesiumMath.toRadians(bounds.getWest())), tilingScheme.rectangle.west);
    swScratch.latitude = Math.max(CesiumMath.toRadians(bounds.getSouth()), tilingScheme.rectangle.south);
    let sw = tilingScheme.positionToTileXY(swScratch, zoom, swTileCoordinatesScratch);
    if (!isDefined(sw)) {
      sw = swTileCoordinatesScratch;
      sw.x = 0;
      sw.y = tilingScheme.getNumberOfYTilesAtLevel(zoom) - 1;
    }
    neScratch.longitude = Math.min(CesiumMath.negativePiToPi(CesiumMath.toRadians(bounds.getEast())), tilingScheme.rectangle.east);
    neScratch.latitude = Math.min(CesiumMath.toRadians(bounds.getNorth()), tilingScheme.rectangle.north);
    let ne = tilingScheme.positionToTileXY(neScratch, zoom, neTileCoordinatesScratch);
    if (!isDefined(ne)) {
      ne = neTileCoordinatesScratch;
      ne.x = tilingScheme.getNumberOfXTilesAtLevel(zoom) - 1;
      ne.y = 0;
    }
    const nextCredits = [];
    for (let j = ne.y; j < sw.y; ++j) {
      for (let i = sw.x; i < ne.x; ++i) {
        const credits = this.imageryProvider.getTileCredits(i, j, zoom);
        if (!defined(credits)) {
          continue;
        }
        for (let k = 0; k < credits.length; ++k) {
          const credit = credits[k];
          if (credit._shownInLeaflet) {
            continue;
          }
          credit._shownInLeaflet = true;
          nextCredits.push(credit);
          if (!credit._shownInLeafletLastUpdate) {
            this._map.attributionControl.addAttribution(getCreditHtml(credit));
          }
        }
      }
    }

    // Remove attributions that applied last update but not this one.
    for (let i = 0; i < this._previousCredits.length; ++i) {
      if (!this._previousCredits[i]._shownInLeaflet) {
        this._map.attributionControl.removeAttribution(getCreditHtml(this._previousCredits[i]));
        this._previousCredits[i]._shownInLeafletLastUpdate = false;
      }
    }
    this._previousCredits = nextCredits;
  }
  async getFeaturePickingCoords(map, longitudeRadians, latitudeRadians) {
    const ll = new Cartographic(CesiumMath.negativePiToPi(longitudeRadians), latitudeRadians, 0.0);
    const level = Math.round(map.getZoom());
    const tilingScheme = this.imageryProvider.tilingScheme;
    const coords = tilingScheme.positionToTileXY(ll, level);
    return {
      x: coords.x,
      y: coords.y,
      level: level
    };
  }
  async pickFeatures(x, y, level, longitudeRadians, latitudeRadians) {
    try {
      return await this.imageryProvider.pickFeatures(x, y, level, longitudeRadians, latitudeRadians);
    } catch (e) {
      TerriaError.from(e, "An error ocurred while calling `ImageryProvider#.pickFeatures`. `ImageryProvider.url = ".concat(this.imageryProvider.url, "`")).log();
    }
  }
  onRemove(map) {
    if (this._delayedUpdate) {
      clearTimeout(this._delayedUpdate);
      this._delayedUpdate = undefined;
    }
    for (let i = 0; i < this._previousCredits.length; ++i) {
      this._previousCredits[i]._shownInLeafletLastUpdate = false;
      this._previousCredits[i]._shownInLeaflet = false;
      map.attributionControl.removeAttribution(getCreditHtml(this._previousCredits[i]));
    }
    if (this._usable && defined(this.imageryProvider.credit)) {
      map.attributionControl.removeAttribution(getCreditHtml(this.imageryProvider.credit));
    }
    L.TileLayer.prototype.onRemove.apply(this, [map]);

    // Check that this cancels tile requests when dragging the time slider and rapidly creating
    // and destroying layers.  If the image requests for previous times/layers are allowed to hang
    // around, they clog up the pipeline and it takes approximately forever for the browser
    // to get around to downloading the tiles that are actually needed.
    this._abortLoading();
    return this;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "splitDirection", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return SplitDirection.NONE;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "splitPosition", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0.5;
  }
}), _applyDecoratedDescriptor(_class.prototype, "_clipsForSplitter", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "_clipsForSplitter"), _class.prototype), _class);
export { ImageryProviderLeafletTileLayer as default };
function getCreditHtml(credit) {
  return credit.element.outerHTML;
}